<template>
  <main class="min-h-screen">
    <Toast />
    <Loader />
    <Header :mode="mode" @toggle="toggle" v-if="!$route.meta.isError" />
    <div :class="[!$route.meta.isError ? 'py-[48px] md:py-[32px]' : '']">
      <RouterView :mode="mode" :key="$route.path" />
    </div>
    <Footer :mode="mode" v-if="!$route.meta.isError" />
  </main>
</template>

<script>
import Header from "@C/Layouts/Header.vue";
import Footer from "@C/Layouts/Footer.vue";
import Toast from "@C/Layouts/Toast.vue";
import Loader from "@C/Layouts/Loader.vue";
import { useGlobalErrorHandler } from "@L/errorHandler";
import ApiRequest from "@L/ApiRequest";
import { useToastStore } from "@S/toast";
import { useUserStore } from "@S/user";
import { useCountriesStore } from "@S/countries";

export default {
  name: "App",
  components: {
    Toast,
    Loader,
    Header,
    Footer,
  },
  setup() {
    const toastStore = useToastStore();
    const userStore = useUserStore();
    const countriesStore = useCountriesStore();
    const { handleError } = useGlobalErrorHandler();
    return {
      toastStore,
      userStore,
      countriesStore,
      handleError,
    };
  },
  data() {
    return {
      mode: localStorage.getItem("mode") || "light",
    };
  },
  mounted() {
    this.mode === "dark"
      ? document.body.classList.add("dark")
      : document.body.classList.remove("dark");
    this.getCountries();
  },
  methods: {
    toggle() {
      if (this.mode === "dark") {
        this.mode = "light";
      } else {
        this.mode = "dark";
      }
      localStorage.setItem("mode", this.mode);
      this.mode === "dark"
        ? document.body.classList.add("dark")
        : document.body.classList.remove("dark");
    },
    async getUserSession() {
      try {
        const { data } = await ApiRequest().get(`/me`);
        if (data && data?.error === "") {
          this.userStore.setUser(data);
          if (this.$route.name === "signin") {
            this.$router.push({ name: "home" });
          }
          return;
        }
        this.userStore.setUser(null);
        this.$router.push({ name: "signin" });
      } catch (e) {
        this.handleError(e);
      }
    },
    async getCountries() {
      try {
        const { data } = await ApiRequest().get(`/countries`);
        if (data) {
          this.countriesStore.setCountries(data);
        }
      } catch (e) {
        this.handleError(e);
      }
    },
  },
  watch: {
    $route(to) {
      if (to.name === "agreement") {
        return;
      }
      this.getUserSession();
    },
  },
};
</script>
